import React, { useState } from 'react';
import {
  ImageTextLink,
  Paragraph,
  StackedColumn,
  StackedColumnSpacing,
} from '../../../../../core';
import { ArrowRightImage } from '../../../../../core/assets/images';
import {
  DateTimeFilter,
  ProviderDetails,
  ProviderSummary,
  SlotDateGroup,
} from '../../../../../api/models';
import { SimilarProvidersDialog } from './similarProvidersDialog';

interface DateTimeStepFooterProps {
  alternateProviders: ProviderSummary[];
  filter: DateTimeFilter;
  onCareProviderSelected: (
    newProviderDetails: ProviderDetails,
    availableAppointmentSlots?: SlotDateGroup[]
  ) => void;
}

const DateTimeStepFooter: React.FC<DateTimeStepFooterProps> = (
  props: DateTimeStepFooterProps
) => {
  const [showSimilarProvidersModal, setShowSimilarProvidersModal] =
    useState<boolean>(false);

  const onSimilarProvidersClicked = () => {
    setShowSimilarProvidersModal(true);
  };

  const onCloseSimilarProvidersModal = () => {
    setShowSimilarProvidersModal(false);
  };

  const onCareProviderSelected = (
    newProviderDetails: ProviderDetails,
    availableAppointmentSlots?: SlotDateGroup[]
  ) => {
    props.onCareProviderSelected(newProviderDetails, availableAppointmentSlots);
    setShowSimilarProvidersModal(false);
  };

  return (
    <>
      <StackedColumn spacing={StackedColumnSpacing.NoGap}>
        <Paragraph text="Need an appointment as soon as possible?" />
        <ImageTextLink
          caption="View similar care providers"
          imageSource={ArrowRightImage}
          onClick={onSimilarProvidersClicked}
        />
      </StackedColumn>
      {showSimilarProvidersModal ? (
        <SimilarProvidersDialog
          isOpen={showSimilarProvidersModal}
          alternateProviders={props.alternateProviders}
          filter={props.filter}
          onCareProviderSelected={onCareProviderSelected}
          onClose={onCloseSimilarProvidersModal}
        />
      ) : null}
    </>
  );
};

export default DateTimeStepFooter;
